import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { TextField } from '@metarouter-private/mr-mui';

const DEBOUNCE_MS = 300;

export default function UserFilter({ value, onChange }) {
  const [inputValue, setInputValue] = useState(value ?? '');
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const debouncedOnChange = useRef(debounce(next => onChangeRef.current(next.trim() || null), DEBOUNCE_MS)).current;

  useEffect(() => () => debouncedOnChange.cancel(), [debouncedOnChange]);

  const handleChange = event => {
    setInputValue(event.target.value);
    debouncedOnChange(event.target.value);
  };

  return (
    <TextField
      data-test-id="auditLogUserFilter"
      label="User"
      placeholder="Name or email"
      fullWidth
      value={inputValue}
      onChange={handleChange}
    />
  );
}

UserFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
